export const url = '/data-sync';
